// Tiny hook to read user notification prefs once at mount and expose
// the activity_feedback_enabled toggle. Cheap polling-free cache —
// flipped via Settings, refreshed on next mount.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _prefsCache = null;
let _prefsPromise = null;

async function _load() {
  if (_prefsCache) return _prefsCache;
  if (_prefsPromise) return _prefsPromise;
  _prefsPromise = api.get("/users/me/notification-settings")
    .then(({ data }) => { _prefsCache = data; _prefsPromise = null; return data; })
    .catch(() => ({ activity_feedback_enabled: true }));
  return _prefsPromise;
}

export function useActivityFeedbackEnabled() {
  const [enabled, setEnabled] = useState(_prefsCache ? !!_prefsCache.activity_feedback_enabled : true);
  useEffect(() => {
    _load().then((p) => setEnabled(p.activity_feedback_enabled !== false));
  }, []);
  return enabled;
}

export function clearPrefsCache() {
  _prefsCache = null;
  _prefsPromise = null;
}
